import { render, staticRenderFns } from "./ComponentThresholdConfig.vue?vue&type=template&id=159d70ad"
import script from "./ComponentThresholdConfig.vue?vue&type=script&lang=js"
export * from "./ComponentThresholdConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports